'use client';

import { Autocomplete } from '@mui/material';

import { styled } from '../../styles';

import { AutocompleteProps } from './types';

export const StyledAutocomplete = styled(
  Autocomplete as React.ComponentType<AutocompleteProps>,
)<AutocompleteProps>();
